import {
  FieldLabel,
  FieldValue,
  Stack,
  TextInput,
} from '@lightspeed/design-system-react'
import { useT } from '@transifex/react'

import React from 'react'
import { ApiCustomer } from '@vend/types'
import { CUSTOMER_NAME_FIELD } from '../../../../../react/modals/common/types'
import { LineItemFulfilmentCustomerHeaderView } from '../LineItemFulfilmentCustomerHeaderView'
import { LineItemFulfilmentCustomerContactView } from '../LineItemFulfilmentCustomerContactView'

type LineItemFulfilmentNewCustomerDetailsViewProps = {
  customer: ApiCustomer | null
  onFirstNameChange: (firstName: string) => void
  onLastNameChange: (lastName: string) => void
  onEmailChange: (email: string) => void
  onPhoneNumberChange: (phoneNumberType: string, phoneNumber: string) => void
  isEmailInvalid: boolean
}

export const LineItemFulfilmentNewCustomerDetailsViewLegacy: React.FC<LineItemFulfilmentNewCustomerDetailsViewProps> = ({
  customer,
  onFirstNameChange,
  onLastNameChange,
  onEmailChange,
  onPhoneNumberChange,
  isEmailInvalid,
}: LineItemFulfilmentNewCustomerDetailsViewProps) => {
  const t = useT()
  return (
    <Stack space={6}>
      <LineItemFulfilmentCustomerHeaderView />
      <FieldLabel label={t('First Name')}>
        <FieldValue>
          <TextInput
            placeholder={t('Enter first name')}
            onChange={event => {
              onFirstNameChange(event.target.value)
            }}
            name={CUSTOMER_NAME_FIELD.FIRSTNAME}
            value={customer?.first_name || ''}
          />
        </FieldValue>
      </FieldLabel>
      <FieldLabel label={t('Last Name')}>
        <FieldValue>
          <TextInput
            placeholder={t('Enter last name')}
            onChange={event => {
              onLastNameChange(event.target.value)
            }}
            name={CUSTOMER_NAME_FIELD.LASTNAME}
            value={customer?.last_name || ''}
          />
        </FieldValue>
      </FieldLabel>
      <LineItemFulfilmentCustomerContactView
        customer={customer}
        onEmailChange={onEmailChange}
        onPhoneNumberChange={onPhoneNumberChange}
        isEmailInvalid={isEmailInvalid}
      />
    </Stack>
  )
}
